import React from 'react';
import PropTypes from 'prop-types';

function FileUploadInput({
  setFile,
  infoMsg,
}) {
  const handleFileOnChange = (e) => {
    const fileObj = e.target.files && e.target.files[0];
    if (!fileObj) {
      return;
    }
    setFile(fileObj);
  };

  return (
    <>
      <div className="form-group row mb-0">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="col-form-label col-sm-3">
          {' '}
        </label>
        <div className="col-sm-8">
          <input
            type="file"
            onChange={handleFileOnChange}
            className="form-control-file always-inline"
            accept=".doc,.docx,.xml,.txt,.png,.jpg,.csv"
          />
        </div>
      </div>
      {
        infoMsg
          && (
          <div className="form-group row mt-0">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="col-form-label col-sm-3">
              {' '}
            </label>
            <div className="col-sm-8">
              <div className="text-muted">
                <small>
                  {infoMsg}
                </small>
              </div>
            </div>
          </div>
          )
      }
    </>
  );
}

FileUploadInput.defaultProps = {
  infoMsg: null,
};

FileUploadInput.propTypes = {
  setFile: PropTypes.func.isRequired,
  infoMsg: PropTypes.string,
};

export default FileUploadInput;
